import { render } from "./Process.vue?vue&type=template&id=5524cd1b&scoped=true"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"

import "./Process.vue?vue&type=style&index=0&id=5524cd1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5524cd1b"]])

export default __exports__